import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

function useSearchParamsCustom() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, ] = useSearchParams();

  function getSearchParam(key) {
    return searchParams.get(key);
  }

  const params = new URLSearchParams(location.search);

  function setSearchParamsCustom(key, value) {
    params.set(key, value);
    navigate(`?${params.toString()}`, { replace: true });
  }

  function deleteSearchParam(key) {
    params.delete(key);
    navigate(`?${params.toString()}`, { replace: true });
  }

  return {
    getSearchParam,
    setSearchParamsCustom,
    deleteSearchParam,
    searchParams: params,
  };
}

export default useSearchParamsCustom;
